import { environment } from "../../../../environments/environment";

export class PageHeader {
    constructor(
        public pageSize: number = environment.apiUrl.pageDefaultSize,
        public totalItems: number = 0,
        public pageNumber: number = 0,
        public totalPages: number = 1
    ) { }
}